import { Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';

const AdminRoute = ({ children }) => {
    const [isChecking, setIsChecking] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        const checkAuth = () => {
            // Check for admin authentication token
            const adminToken = localStorage.getItem('adminToken');
            setIsAuthenticated(!!adminToken);
            setIsChecking(false);
        };
        
        checkAuth();
    }, []);

    if (isChecking) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-secondary"></div>
            </div>
        );
    }

    // Redirect to login if not authenticated
    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    return children;
};

export default AdminRoute; 